import React from 'react'
import './commontextimage.scss'
import { Row, Col } from 'react-bootstrap'
const MainTextImage = ({ data, showImage = "true", heading }) => {
    return (
        <div className='textimageinfo'>
            <Row>
                {showImage && (
                    <Col sm={12} md={4} lg={4} xl={4}>
                        {data.map((item , index) => (
                            <div key={index} className='right-image'>
                                <img src={item.image} alt='logo' />
                            </div>
                        ))}
                    </Col>
                )}
                <Col sm={12} md={8} lg={8} xl={8}>
                    <div className='left-details'>
                        <div className='Heading'>
                            <h3>{heading}</h3>
                        </div>
                        <div className='text'>
                            {data.map((item , index) => (
                                <>
                                 <div key={index}>
                                    <p>{item.para}</p>
                                    <p>{item.para1}</p>
                                    <a href={item.linkUrl}>{item.linkLabel}</a>
                                 </div>
                                </>
                            ))}
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default MainTextImage